import { Card } from "@/components/ui/card";
import { useQuery } from "@tanstack/react-query";
import { Link, useSearchParams } from "react-router-dom";
import PageHeading from "@/v2/components/ui/heading/Page";
import parseUrlToQueryParams from "../../utils/parseUrlToQueryParams";
import { TableToolbar, DataTable } from "@/v2/components/data-table/table";
import { Quotation } from "@/v2/types";
import FindAllQuotations from "@/v2/api/quotation/FindAll";
import {
    QuotationColumn,
    QuotationFilterColumn,
} from "@/v2/components/data-table/columns/Quotation";
import AccessControl from "@/v2/components/rbac/AccessControl";
import { Button } from "@/components/ui/button";

export default function QuotationPage() {
    const [searchParams, _setSearchParams] = useSearchParams();
    const queryParams = parseUrlToQueryParams(searchParams);

    const { skip, limit, search, filter } = queryParams;

    const { refetch, ...query } = useQuery({
        queryKey: ["quotations", skip, limit, search, filter],
        queryFn: () =>
            FindAllQuotations({
                limit: limit ?? 20,
                skip: skip ?? 0,
                search: search,
                filter,
            }),
    });

    return (
        <>
            <div className="flex flex-wrap items-center justify-between gap-4 py-2">
                <PageHeading
                    title="Quotation"
                    description="Manage and monitor all quotations in your platform"
                />

                <div className="flex gap-4">
                    <AccessControl
                        module="QUOTATION_MANAGEMENT"
                        requestedAccess={"POST"}
                    >
                        <Link to={"create"}>
                            <Button>Generate Quotation</Button>
                        </Link>
                    </AccessControl>
                </div>
            </div>

            <Card className="p-2">
                <TableToolbar<Quotation>
                    column={QuotationFilterColumn}
                    searchPlaceHolder="Search quotations"
                />

                <DataTable<Quotation>
                    data={query.data?.data || []}
                    columns={QuotationColumn}
                    loading={query.isLoading || query.isFetching}
                    pagination={query?.data?.pagination!}
                />
            </Card>
        </>
    );
}
